// extracted by mini-css-extract-plugin
export default {"container":"container--SbGu1","containerTop":"containerTop--jRvZp","containerBottom":"containerBottom--Bu7cd","markerAnimationScale":"markerAnimationScale--j1gIp"};